import { Component, ElementRef, ViewEncapsulation, effect, input, output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Register } from '@xanadu/core';
import { InputComponent } from '@xanadu/input';

@Component({
    selector: 'app-expansion',
    templateUrl: './expansion.component.html',
    styleUrls: ['./expansion.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('expansion')
export class ExpansionComponent extends InputComponent {
    readonly status = input<any>();
    readonly focus = input<any>();
    readonly tagChange = output<{ tag: string; data: any }>();

    readonly titleInput = viewChild<ElementRef<HTMLInputElement>>('titleInput');

    readonly titleControl = new FormControl('', {
        nonNullable: true
    });

    disable = false;

    constructor() {
        super();

        effect(() => {
            if (this.model()) {
                this.titleControl.setValue(this.meta()?.title ?? '', {
                    emitEvent: false
                });
            }
        });

        effect(() => {
            const target = this.focus();
            const model = this.model();

            if (target === model) {
                this.titleInput()?.nativeElement.focus();
            }
        });
    }

    onExpand(): void {
        this.setExpanded(true);
    }

    onCollapse(): void {
        this.setExpanded(false);
    }

    onFocus(): void {
        this.disable = true;
    }

    onBlur(): void {
        this.disable = false;
    }

    onChange(event: Event): void {
        const element = event.target as HTMLInputElement;

        this.tagChange.emit({
            tag: element.value,
            data: this.model()
        });
    }

    private setExpanded(expanded: boolean): void {
        const status = this.status();

        if (status) {
            status.expanded = expanded;
        }
    }
}
